import { salaryHistoryActionTypes } from "./salaryHistoryActionTypes";

const {
  SALARYHISTORY_LIST_LOADING,
  SALARYHISTORY_LIST_LOAD_SUCCESS,
  SALARYHISTORY_LIST_LOAD_FAIL,
  SHOW_EMPLOYEE_SALARY_HISTORY_DETAIL,
  SET_EMPLOYEE_SALARY_DETAILS,
  SET_EMPLOYEE_SALARY_DETAILS_SPECIFIC,
  SET_LOADER_SALARYHISTORY,
  SHOW_Salary_List,
  RESET_SALARY_VIEW,
  SET_LATEST_SALARY,
  CLEAR_SALARY_ERRORS
} = salaryHistoryActionTypes;

const INITIAL_STATE = {
  salaryHistories: [],
  salaryHistory: {
    Salary: "",
    Designation: "",
    Level: "",
    EmployeeId: "",
    FirstName: "",
    LastName: ""
  },
  salaryHistoryErrors: {
    Salary: "",
    Designation: "",
    Level: ""
  },
  ResetSalaryView: false,
  editSalaryHistoryRecord: {},
  listAllSalaryHistories: true,
  editSalaryHistory: false,
  isLoading: false,
  error: "",
  employeesSalaryListView: true,
  EmployeeSalaryHistoryView: false
};

export default function salaryHistoryReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SALARYHISTORY_LIST_LOADING:
      return { ...state, isLoading: true };
    case SET_EMPLOYEE_SALARY_DETAILS:
      return {
        ...state,
        SalaryArray: action.payload
      };
    case SET_EMPLOYEE_SALARY_DETAILS_SPECIFIC:
      return {
        ...state,
        SpecificSalary: action.payload.SpecificSalary
      };

    case SET_LATEST_SALARY:
      return {
        ...state,
        salaryHistory: action.payload.salaryHistory
      };
    case SET_LOADER_SALARYHISTORY:
      return {
        ...state,
        loading: action.isLoading
      };
    case SALARYHISTORY_LIST_LOAD_SUCCESS:
      return {
        ...state,
        salaryHistories: action.payload,
        isLoading: false
      };
    case SALARYHISTORY_LIST_LOAD_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case SHOW_EMPLOYEE_SALARY_HISTORY_DETAIL:
      return {
        ...state,
        EmployeeSalaryHistoryView: true,
        employeesSalaryListView: false
      };
    case SHOW_Salary_List:
      return {
        ...state,
        EmployeeSalaryHistoryView: false,
        employeesSalaryListView: true
      };
    case RESET_SALARY_VIEW:
      return {
        ...state,
        ResetSalaryView: action.value,
        employeesSalaryListView: action.value
      };
    case CLEAR_SALARY_ERRORS:
      return {
        ...state,
        salaryHistoryErrors: { ...state.salaryHistoryErrors }
      };
    default:
      return state;
  }
}
